import React from 'react';

import {ArchiveTableRowProps, getRowClassName} from 'archive/components/modals/ArchiveTableRowConstants';
import ContainerArchiveTableRowType from 'archive/components/modals/ContainerArchiveTableRowType';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ShortcutIcon from 'ui-library/icons/ShortcutIcon';
import APIUtil from 'util/APIUtil';

export function ArchiveTableRowType({itemForArchive, options}: ArchiveTableRowProps): JSX.Element {
  if (APIUtil.isContainer(itemForArchive.id)) {
    return <ContainerArchiveTableRowType itemForArchive={itemForArchive} options={options} />;
  }
  const IconClass = itemForArchive.isShortcut ? ShortcutIcon : BenchlingIcon;
  return (
    <div className={getRowClassName(itemForArchive, options)}>
      <IconClass className="faded" icon={itemForArchive.iconId} />
      <span className="u-small-spacing-left">{itemForArchive.friendlyTypeName}</span>
    </div>
  );
}
